'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { PropertyCardRootContext } from './context/property-card-root.context';
import { propertyCardDataWrapperRecipe } from './styles/property-card-data-wrapper.styles';
import type { PropertyCardDataWrapperPropsInterface } from './types/property-card-data-wrapper.types';

/**
 * A container for the property data and action buttons in a `PropertyCard`.
 *
 * @since 8.63.0
 */
export const PropertyCardDataWrapper = forwardRef<
  HTMLDivElement,
  PropertyCardDataWrapperPropsInterface
>((props: PropertyCardDataWrapperPropsInterface, forwardedRef) => {
  const { appearance = 'large' } = useContext(PropertyCardRootContext);
  const { children, className, css: cssProp, ...rest } = props;

  const styles = css(propertyCardDataWrapperRecipe.raw({ appearance }), cssProp);

  return (
    <div
      ref={forwardedRef}
      data-c11n-component="PropertyCard.DataWrapper"
      data-c11n-version={__C11N_VERSION__}
      className={cx('c11n', styles, className)}
      {...rest}
    >
      {children}
    </div>
  );
});

PropertyCardDataWrapper.displayName = 'PropertyCard.DataWrapper';
